import { render } from "./vacation.vue?vue&type=template&id=74f3eddf"
import script from "./vacation.vue?vue&type=script&lang=js"
export * from "./vacation.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/host/imc/tender/dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"vue/js/components/shared/user/user_block/vacation.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "74f3eddf"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('74f3eddf', __exports__)) {
    console.log('reload')
    api.reload('74f3eddf', __exports__)
  }
  
  module.hot.accept("./vacation.vue?vue&type=template&id=74f3eddf", () => {
    console.log('re-render')
    api.rerender('74f3eddf', render)
  })

}


export default __exports__